<template>
    <div>
        <div>
            <table v-if="wayBill">
                <tr class="th">
                    <td>品牌</td>
                    <td>cas号</td>
                    <td>发货数量</td>
                    <td>产品编码</td>
                    <td>产品名称</td>
                    <td>货号</td>
                </tr>
                <tbody>
                    <tr v-for="(item, index) in wayBill" :key="index">
                        <td>{{item.brandName}}</td>
                        <td>{{item.casCode}}</td>
                        <td>{{item.deliverAmount}}</td>
                        <td>{{item.proCode}}</td>
                        <td>{{item.proName}}</td>
                        <td>{{item.specsNo}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="table-empty" v-if="wayBill.length === 0">
                <i class="el-icon-document-copy"></i>
                <p>暂无数据</p>
            </div>
        </div>
    </div>
</template>

<script>
import * as apis from '../../fetch/order';

export default {
    name: 'WayBill',
    props: ['wayBillId'],
    data() {
        return {
            wayBill: [],
        };
    },
    watch: {
        wayBillId(val) {
            this.getWayBillDetail();
        },
    },
    methods: {
        getWayBillDetail() {
            apis.getWayBillDetail({ waybillId: this.wayBillId }).then(res => {
                this.wayBill = res;
            });
        },
    },
    mounted() {
        this.getWayBillDetail();
    },
};
</script>


<style scoped lang="scss">
</style>